import React from 'react';
import _ from 'i18n';

const RankingOrganizationsListFetching = () => (
  <table className="unstriped hover">
    <thead>
      <tr>
        <th width="150" className="text-center"><label>{_('Rank')}</label></th>
        <th className="text-center"><label>{_('Organization')}</label></th>
        <th width="200" className="text-center">
          <label>{_('Nps')}</label>
        </th>
        <th width="200" className="text-center">
          <label>
            {_('Global Nps')}
          </label>
        </th>
        <th width="200" className="text-center">
          <label>
            {_('Coast')}
          </label>
        </th>
      </tr>
    </thead>
    <tbody className="list-fetching">
      {
        Array.from(Array(5).keys()).map(item => (
          <tr key={item}>
            <td className="text-center cell-rank"><h5 className="gradiant" /></td>
            <td className="text-left"><h5 className="gradiant" /></td>
            <td className="text-center">--</td>
            <td className="text-center">--</td>
            <td className="text-center">--</td>
          </tr>
        ))
      }
    </tbody>
  </table>
);

export default RankingOrganizationsListFetching;
